export const selectField = {
  option: {
    class: ['tw-truncate'],
  },
  overlay: {
    class: ['tw-text-[16px] tw-font-sans tw-font-normal tw-text-black', 'tw-max-w-[75ch]'],
  },
};
